export { default } from "./ScaleSliderQuestionCard"